<template>
  <!-- 邀请注册弹框 -->
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    :title="$t('login.invitationRegistration')"
    :visible.sync="registerDialog"
    top="10vh"
    width="750px"
  >
    <!-- 引导说明文字 -->
    <div class="dialog-desc">
      {{ $t('login.invitationRegistrationInstruction') }}
    </div>
    <!-- 主体内容区：链接 + 二维码 -->
    <div class="dialog-content">
      <!-- 左侧链接区域 -->
      <div class="link-section">
        <div class="link-text" @click="toLink">{{ registerLink }}</div>
        <el-button
          class="copy-btn" icon="el-icon-document" size="small"
          @click="copyLink"
        >
          {{ $t('login.copyLink') }}
        </el-button>
      </div>
      <!-- 右侧二维码区域 -->
      <div class="qrcode-section">
        <div ref="qrcodeContainer" class="qrcode-box" style="width: 150px; height: 150px" />
        <el-button
          class="copy-btn"
          icon="el-icon-document"
          size="mini"
          style="margin-top: 10px"
          @click="copyQrcode"
        >
          {{ $t('login.copyQrCode') }}
        </el-button>
      </div>
    </div>
    <!-- 底部提示 -->
    <div class="dialog-tip">{{ $t('login.encryptedTamperProofNotice') }}</div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeBtn">{{ $t('GlobalSetObj.Close') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
// 先安装：npm install qrcode-generator --save
import qrcode from 'qrcode-generator';
import { copyData } from '@/utils/copyData';

export default {
  name: 'InviteRegisterDialog',
  data() {
    return {
      registerDialog: false,
      registerLink: '',
      qrImage: null // 只加这一行
    };
  },
  watch: {
    // 监听弹框显示，显示时自动生成二维码
    registerDialog(val) {
      if (val) {
        this.$nextTick(() => {
          this.createQrcode();
        });
      }
    }
  },
  methods: {
    // 打开弹框
    showRegisterDialog(link) {
      if (link) {
        this.registerLink = link;
        this.registerDialog = true;
      }
    },
    toLink() {
      window.open(this.registerLink);
    },
    // 关闭弹框
    closeBtn() {
      this.registerDialog = false;
    },

    // 使用 qrcode-generator 生成二维码（只改最后3行，其余不动）
    createQrcode() {
      const container = this.$refs.qrcodeContainer;
      if (!container) return;
      container.innerHTML = '';

      this.$nextTick(() => {
        const link = this.registerLink.trim();
        const qr = qrcode(0, 'M');
        qr.addData(link);
        qr.make();
        const img = qr.createImgTag(3, 5, '邀请注册二维码');
        container.innerHTML = img;

        const image = container.querySelector('img');
        if (image) this.qrImage = image;
      });
    },

    // 复制链接（完全不动）
    async copyLink() {
      try {
        copyData(this.registerLink);
      } catch (e) {
        this.$message.error(this.$t('login.copyFailed'));
      }
    },

    // 复制二维码（只重写这个方法，实现粘贴功能）
    async copyQrcode() {
      try {
        if (!this.qrImage) {
          this.$message.error(this.$t('login.qrCodeNotGenerated'));
          return;
        }

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = this.qrImage.width;
        canvas.height = this.qrImage.height;
        ctx.drawImage(this.qrImage, 0, 0);

        // 转成 blob
        canvas.toBlob((blob) => {
          // 判断浏览器是否支持 ClipboardItem
          if (navigator.clipboard && window.ClipboardItem) {
            const item = new ClipboardItem({ 'image/png': blob });
            navigator.clipboard
              .write([item])
              .then(() => {
                this.$message.success(this.$t('orderCenterCont.ReplicationSucceeded'));
              })
              .catch(() => {
                this.$message.warning(this.$t('login.copyFailedSaveImageManually'));
              });
          } else {
            // 不支持的浏览器，直接提示右键保存
            this.$message.error(this.$t('login.browserNoImageCopySupport'));
          }
        }, 'image/png');
      } catch (e) {
        console.error(e);
        this.$message.warning(this.$t('login.copyFailedSaveImageManually'));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-desc {
  font-size: 16px;
  color: #303133;
  margin-bottom: 20px;
}

.dialog-content {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
}

.link-section {
  flex: 1;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 15px;
  display: flex;
  flex-direction: column;

  .link-text {
    color: #67c23a;
    word-break: break-all;
    font-size: 14px;
    margin-bottom: 15px;
    cursor: pointer;
  }
}

.qrcode-section {
  width: 200px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.dialog-tip {
  font-size: 14px;
  color: #909399;
}

.dialog-footer {
  text-align: right;
}
</style>
